const actions = {
    RESET_MESSAGE: "RESET_MESSAGE",

    CREATE_BULK_ADDITIONAL_SERVICE: "CREATE_BULK_ADDITIONAL_SERVICE",
    CREATE_BULK_ADDITIONAL_SERVICE_SUCCESS: "CREATE_BULK_ADDITIONAL_SERVICE_SUCCESS",
    CREATE_BULK_ADDITIONAL_SERVICE_FAILED: "CREATE_BULK_ADDITIONAL_SERVICE_FAILED",

    GET_ADDITIONAL_SERVICE: "GET_ADDITIONAL_SERVICE",
    GET_ADDITIONAL_SERVICE_SUCCESS: "GET_ADDITIONAL_SERVICE_SUCCESS",
    GET_ADDITIONAL_SERVICE_FAILED: "GET_ADDITIONAL_SERVICE_FAILED",

    getAdditionalService: (data) => ({
        type: actions.GET_ADDITIONAL_SERVICE,
        payload: { data }
    }),
    getAdditionalServiceSuccess: (message, data) => ({
        type: actions.GET_ADDITIONAL_SERVICE_SUCCESS,
        payload: { message, data }
    }),
    getAdditionalServiceFailed: (error) => ({
        type: actions.GET_ADDITIONAL_SERVICE_FAILED,
        payload: { error }
    }),

    createBulkAdditionalService: (data) => ({
        type: actions.CREATE_BULK_ADDITIONAL_SERVICE,
        payload: { data }
    }),
    createBulkAdditionalServiceSuccess: (message) => ({
        type: actions.CREATE_BULK_ADDITIONAL_SERVICE_SUCCESS,
        payload: { message }
    }),
    createBulkAdditionalServiceFailed: (error) => ({
        type: actions.CREATE_BULK_ADDITIONAL_SERVICE_FAILED,
        payload: { error }
    }),

    resetMessage: (data) => ({
        type: actions.RESET_MESSAGE,
    }),

}
export default actions;